// Scripts
import noUiSlider from 'nouislider'
import wNumb from '../../js/libs/wnumb-1.2.0/wNumb.min.js'

// Styles
import '../../scss/components/forms'
import 'nouislider/dist/nouislider.css'
import '../../scss/components/offersSearchForm'

// Locations Autocomplete
function getLocAutocomplete (formEl) {
  import(/* webpackChunkName: "offersLocationsAutocomplete" */ './offersLocationsAutocomplete.js').then(module => {
    module.offersLocAutocomplete.init(formEl)
  })
}

const osForm = {

  init () {
    document.querySelectorAll('form[name="osForm"]').forEach(form => {
      // autocomplete
      const loadAutoComplete = function (e) {
        const formEl = e.target.closest('form')
        const el = e.target
        el.blur()
        el.setAttribute('disabled', 'disabled')
        el.value = 'Veuillez patienter...'

        // remove all listeners to close button : https://stackoverflow.com/questions/19469881/remove-all-event-listeners-of-specific-type
        const elClone = el.cloneNode(true)
        el.parentNode.replaceChild(elClone, el)
        getLocAutocomplete(formEl)
      }
      const location = form.querySelector('input[name="location"]')
      if (!location.classList.contains('autocomplete_initialized')) {
        location.addEventListener('click', loadAutoComplete)
        location.addEventListener('keyup', loadAutoComplete)
        location.addEventListener('focus', loadAutoComplete)
      }

      // superficie
      const range1 = form.querySelector('.surface-range')
      if (range1) {
        const surfaceFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' m²'
        })
        const skipValues = [
          form.querySelector('.surface-value-min'),
          form.querySelector('.surface-value-max')
        ]
        const inputValues = [
          form.querySelector('input[name="surface_from"]'),
          form.querySelector('input[name="surface_to"]')
        ]
        const minv = parseInt(form.querySelector('input[name="surface_min"]').value)
        const maxv = parseInt(form.querySelector('input[name="surface_max"]').value)
        noUiSlider.create(range1, {
          start: [minv, maxv],
          step: 10,
          connect: true,
          range: {
            min: minv,
            max: maxv
          },
          format: surfaceFormat
        })
        if (inputValues[0].value !== '' && inputValues[1].value !== '') {
        // if (inputValues[0].value !== '') {
          range1.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          range1.noUiSlider.set([minv, maxv]) // affecte les valeurs par défaut
        }
        range1.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (surfaceFormat.from(values[handle]) === maxv) {
            skipValues[handle].innerHTML = values[handle] + '&nbsp;<small>et&nbsp;+</small>'
          }
          inputValues[handle].value = surfaceFormat.from(values[handle])
        })
      }

      // budget
      const range2 = form.querySelector('.budget-range')
      if (range2) {
        const moneyFormat = wNumb({
          decimals: 0,
          thousand: '.',
          postfix: ' €'
        })
        const skipValues = [
          form.querySelector('.budget-value-min'),
          form.querySelector('.budget-value-max')
        ]
        const inputValues = [
          form.querySelector('input[name="budget_from"]'),
          form.querySelector('input[name="budget_to"]')
        ]
        const minv2 = parseInt(form.querySelector('input[name="budget_min"]').value)
        const maxv2 = parseInt(form.querySelector('input[name="budget_max"]').value)
        noUiSlider.create(range2, {
          start: [minv2],
          step: 10000,
          connect: [true, false],
          range: {
            min: minv2,
            max: maxv2
          },
          format: moneyFormat
        })
        // if (inputValues[0].value !== '' && inputValues[1].value !== '') {
        if (inputValues[0].value !== '') {
          range2.noUiSlider.set([inputValues[0].value, inputValues[1].value]) // affecte les valeurs
        } else {
          range2.noUiSlider.set([maxv2]) // affecte les valeurs par défaut
        }
        range2.noUiSlider.on('update', function (values, handle) { // relie le snap aux inputs
          skipValues[handle].innerHTML = values[handle]
          if (moneyFormat.from(values[handle]) === maxv2) {
            skipValues[handle].innerHTML = values[handle] + '&nbsp;<small>et&nbsp;+</small>'
          }
          inputValues[handle].value = moneyFormat.from(values[handle])
        })
      }

      // on raz
      form.querySelector('button[name="btn_raz"]').addEventListener('click', function () {
        form.reset()
        const minv = parseInt(form.querySelector('input[name="surface_min"]').value)
        const maxv = parseInt(form.querySelector('input[name="surface_max"]').value)
        form.querySelector('input[name="surface_from"]').value = minv
        form.querySelector('input[name="surface_to"]').value = maxv
        const minv2 = parseInt(form.querySelector('input[name="budget_min"]').value)
        const maxv2 = parseInt(form.querySelector('input[name="budget_max"]').value)
        form.querySelector('input[name="budget_from"]').value = maxv2
        form.querySelector('input[name="budget_to"]').value = minv2
        form.submit()
      })

      // on submit
      form.addEventListener('submit', e => {
        const form = e.target
        const slug = form.querySelector('input[name="slug"]').value
        if (slug !== '') {
          form.setAttribute('action', form.getAttribute('action') + '/' + slug)
        }
      })
    })
  }

}

osForm.init()
